let gridHandlers = document.querySelectorAll('.grid-template-products .view button');
let parentElem = document.querySelectorAll('#product-grid .product-item');
let touchStart,touchEnd 

gridHandlers.forEach((gridHandler) => {
    gridHandler.addEventListener('click', function (e) {
        e.preventDefault();
        gridHandlers.forEach(elm => elm.classList.remove('active'));
        e.currentTarget.classList.add('active');
        let parentElemClassToAdd = e.currentTarget.getAttribute('data-view'); 
        parentElem.forEach(element => {
            element.classList.remove('grid-4', 'grid-2');
            element.classList.add(parentElemClassToAdd);
        });
    });
})
const slideProductImages = () => {
    document.querySelectorAll('.product-card__images').forEach(img => {
        const images = img.querySelectorAll('.product-card__image');
        img.addEventListener('touchstart', e => {
            touchStart = e.changedTouches[0].screenX;
        });
        img.addEventListener('touchend', e => {
            touchEnd = e.changedTouches[0].screenX;
            const [firstImage, secondImage] = images;
            if (touchStart < touchEnd) {
                secondImage.classList.add('hide-image');
                firstImage.classList.remove('hide-image');
            } else {
                secondImage.classList.remove('hide-image');
                firstImage.classList.add('hide-image');
            }
        });
    });
}
document.addEventListener('theme:collection:filtred', function() {
    slideProductImages();
})
slideProductImages();
